
export const getSpeakersCols = (t, event, isArabic) => {
  return [
    {
      label: t("speakers"),
      path: isArabic ? "name_ar" : "name",
      isImg: true,
      src: "image",
    },
    {
      label: t("time"),

      isTime: true,
    },
    {
      label: t("session_title"),
      path: isArabic ? "session_title_ar" : "session_title",
    },
    {
      label: t("bio"),
      path: isArabic ? "description_ar" : "description",
      width: "50%",
    },
  ];
};
